import script from "./UsersManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersManagement.vue?vue&type=script&setup=true&lang=ts"

import "./UsersManagement.vue?vue&type=style&index=0&id=474818c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474818c2"]])

export default __exports__